/* eslint no-undef: "off"*/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['exports', 'echarts'], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports, require('echarts'));
    } else {
        // Browser globals
        factory({}, root.echarts);
    }
}(this, function (exports, echarts) {
    var log = function (msg) {
        if (typeof console !== 'undefined') {
            console && console.error && console.error(msg);
        }
    }
    if (!echarts) {
        log('ECharts is not Loaded');
        return;
    }
    if (!echarts.registerMap) {
        log('ECharts Map is not loaded')
        return;
    }
    echarts.registerMap('南京', {
        "type": "FeatureCollection",
        "features": [{
            "type": "Feature",
            "properties": {
                "name": "秦淮区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.83298953125, 31.98819846875],
                            [118.797345, 31.973843],
                            [118.792867460938, 31.9960305000001],
                            [118.757345, 32.013843],
                            [118.757345, 32.023843],
                            [118.767345, 32.023843],
                            [118.83205203125, 32.0128517890625],
                            [118.837345, 31.993843],
                            [118.83298953125, 31.98819846875]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "下关区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.733985625, 32.0672023750001],
                            [118.727345, 32.063843],
                            [118.727345, 32.093843],
                            [118.740704375, 32.120483625],
                            [118.767345, 32.133843],
                            [118.793985625, 32.120483625],
                            [118.797345, 32.103843],
                            [118.797345, 32.093843],
                            [118.777345, 32.093843],
                            [118.745426054688, 32.0898171210938],
                            [118.733985625, 32.0672023750001]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "玄武区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.857867460938, 32.1079274726563],
                            [118.911016875, 32.0908303046875],
                            [118.878980742188, 32.0788430000001],
                            [118.883468046875, 32.058843],
                            [118.879698515625, 32.0420436835938],
                            [118.887345, 32.023843],
                            [118.867345, 32.013843],
                            [118.86298953125, 32.01948753125],
                            [118.814605742188, 32.0392897773438],
                            [118.777345, 32.0438430000001],
                            [118.777345, 32.093843],
                            [118.797345, 32.093843],
                            [118.797345, 32.103843],
                            [118.812066679688, 32.0976589179688],
                            [118.857867460938, 32.1079274726563]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "雨花台区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.677345, 31.903843],
                            [118.689537382813, 31.9004201484375],
                            [118.680767851563, 31.8916506171875],
                            [118.677345, 31.903843]
                        ]
                    ],
                    [
                        [
                            [118.677345, 31.903843],
                            [118.656666289063, 31.8989723945313],
                            [118.639928007813, 31.8718093085938],
                            [118.591226835938, 31.886977765625],
                            [118.587345, 31.9238430000001],
                            [118.591793242188, 31.9293971992188],
                            [118.647345, 31.973843],
                            [118.681119414063, 31.9608620429688],
                            [118.710045195313, 31.9572634101563],
                            [118.751793242188, 32.0093971992187],
                            [118.757345, 32.013843],
                            [118.792867460938, 31.9960305000001],
                            [118.797345, 31.973843],
                            [118.77142703125, 31.9597585273438],
                            [118.758819609375, 31.9106227851562],
                            [118.712623320313, 31.9300270820312],
                            [118.682320585938, 31.9232326484375],
                            [118.677345, 31.903843]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "溧水县"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.133922148438, 31.4360353828125],
                            [119.137345, 31.423843],
                            [119.125152617188, 31.4272658515625],
                            [119.133922148438, 31.4360353828125]
                        ]
                    ],
                    [
                        [
                            [118.847345, 31.5138430000001],
                            [118.843922148438, 31.5016506171875],
                            [118.835152617188, 31.5104201484375],
                            [118.847345, 31.5138430000001]
                        ]
                    ],
                    [
                        [
                            [118.847345, 31.5138430000001],
                            [118.847345, 31.523843],
                            [118.857345, 31.523843],
                            [118.857345, 31.5138430000001],
                            [118.847345, 31.5138430000001]
                        ]
                    ],
                    [
                        [
                            [118.857345, 31.523843],
                            [118.857345, 31.533843],
                            [118.867345, 31.533843],
                            [118.867345, 31.523843],
                            [118.857345, 31.523843]
                        ]
                    ],
                    [
                        [
                            [118.867345, 31.533843],
                            [118.873136015625, 31.569106671875],
                            [118.86156375, 31.5985500312501],
                            [118.863765898438, 31.6134548164063],
                            [118.827345, 31.633843],
                            [118.831519804688, 31.6396681953126],
                            [118.883092070313, 31.6500075507813],
                            [118.912037382813, 31.6903884101563],
                            [118.941519804688, 31.6716701484375],
                            [118.932432890625, 31.7130300117188],
                            [118.895128203125, 31.7397682929688],
                            [118.888780546875, 31.771889875],
                            [118.902037382813, 31.7903884101563],
                            [118.921793242188, 31.7778444648438],
                            [118.971519804688, 31.7680178046876],
                            [118.977345, 31.763843],
                            [118.99062625, 31.77056175],
                            [118.997345, 31.783843],
                            [119.057354765625, 31.7910671210938],
                            [119.08271609375, 31.76921409375],
                            [119.093082304688, 31.7571852851563],
                            [119.15197390625, 31.70847190625],
                            [119.1827746875, 31.6891799140625],
                            [119.18068484375, 31.6631813789063],
                            [119.20197390625, 31.6384719062501],
                            [119.22271609375, 31.62921409375],
                            [119.227345, 31.6238430000001],
                            [119.21115359375, 31.589165265625],
                            [119.214815703125, 31.5728102851563],
                            [119.177193632813, 31.5468312812501],
                            [119.184815703125, 31.5128102851563],
                            [119.150206328125, 31.4889138007813],
                            [119.14142703125, 31.4497585273437],
                            [119.137345, 31.443843],
                            [119.12142703125, 31.4397585273438],
                            [119.108995390625, 31.4217482734376],
                            [119.072345, 31.4299636054688],
                            [119.062345, 31.4277223945313],
                            [119.052345, 31.4299636054688],
                            [119.042345, 31.4277223945313],
                            [119.02783328125, 31.4309767890625],
                            [119.001920195313, 31.3855763984375],
                            [118.982345, 31.3899636054688],
                            [118.964459257813, 31.3859548164063],
                            [118.940933867188, 31.4012721992188],
                            [118.90451296875, 31.4650856757813],
                            [118.877345, 31.483843],
                            [118.877345, 31.533843],
                            [118.867345, 31.533843]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "白下区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.863985625, 32.007202375],
                            [118.837345, 31.993843],
                            [118.83205203125, 32.0128517890625],
                            [118.767345, 32.023843],
                            [118.757345, 32.0438430000001],
                            [118.777345, 32.0438430000001],
                            [118.814605742188, 32.0392897773438],
                            [118.86298953125, 32.01948753125],
                            [118.867345, 32.013843],
                            [118.863985625, 32.007202375]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "高淳县"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.940933867188, 31.4012721992188],
                            [118.964459257813, 31.3859548164063],
                            [118.982345, 31.3899636054688],
                            [119.001920195313, 31.3855763984375],
                            [119.02783328125, 31.4309767890625],
                            [119.042345, 31.4277223945313],
                            [119.052345, 31.4299636054688],
                            [119.062345, 31.4277223945313],
                            [119.072345, 31.4299636054688],
                            [119.108995390625, 31.4217482734376],
                            [119.12142703125, 31.4397585273438],
                            [119.137345, 31.443843],
                            [119.161734648438, 31.4375856757813],
                            [119.17142703125, 31.3879274726563],
                            [119.209127226563, 31.3618971992187],
                            [119.19142703125, 31.3197585273438],
                            [119.187345, 31.303843],
                            [119.15170046875, 31.28948753125],
                            [119.14298953125, 31.27819846875],
                            [119.1074621875, 31.2569533515626],
                            [119.092857695313, 31.2380275703126],
                            [119.082345, 31.2395827460938],
                            [119.072345, 31.2381032539063],
                            [119.062345, 31.2395827460938],
                            [119.04478640625, 31.2369875312501],
                            [119.027345, 31.2438430000001],
                            [118.989815703125, 31.2349733710938],
                            [118.957345, 31.2405641914063],
                            [118.942345, 31.2379811835937],
                            [118.887345, 31.2474513984375],
                            [118.784908476563, 31.2298146796876],
                            [118.766588164063, 31.2759157539063],
                            [118.721612578125, 31.2881081367188],
                            [118.717345, 31.3238430000001],
                            [118.753121367188, 31.3886452460938],
                            [118.77447390625, 31.366421125],
                            [118.8419153125, 31.3883058906251],
                            [118.8624621875, 31.4281838203125],
                            [118.861861601563, 31.4575392890626],
                            [118.87224734375, 31.4789430976563],
                            [118.877345, 31.483843],
                            [118.90451296875, 31.4650856757813],
                            [118.940933867188, 31.4012721992188]
                        ],
                        [
                            [119.137345, 31.423843],
                            [119.133922148438, 31.4360353828125],
                            [119.125152617188, 31.4272658515625],
                            [119.137345, 31.423843]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "鼓楼区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.777345, 32.0438430000001],
                            [118.757345, 32.0438430000001],
                            [118.712974882813, 32.0500368476563],
                            [118.727345, 32.063843],
                            [118.733985625, 32.0672023750001],
                            [118.745426054688, 32.0898171210938],
                            [118.777345, 32.093843],
                            [118.777345, 32.0438430000001]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "建邺区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.751793242188, 32.0093971992187],
                            [118.710045195313, 31.9572634101563],
                            [118.681119414063, 31.9608620429688],
                            [118.647345, 31.973843],
                            [118.699053984375, 32.0685646796875],
                            [118.727345, 32.093843],
                            [118.727345, 32.063843],
                            [118.712974882813, 32.0500368476563],
                            [118.757345, 32.0438430000001],
                            [118.767345, 32.023843],
                            [118.757345, 32.023843],
                            [118.757345, 32.013843],
                            [118.751793242188, 32.0093971992187]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "江宁区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.677345, 31.903843],
                            [118.680767851563, 31.8916506171875],
                            [118.689537382813, 31.9004201484375],
                            [118.682320585938, 31.9232326484375],
                            [118.712623320313, 31.9300270820312],
                            [118.758819609375, 31.9106227851562],
                            [118.77142703125, 31.9597585273438],
                            [118.797345, 31.973843],
                            [118.83298953125, 31.98819846875],
                            [118.837345, 31.993843],
                            [118.863985625, 32.007202375],
                            [118.867345, 32.013843],
                            [118.887345, 32.023843],
                            [118.90162234375, 32.0348635078126],
                            [118.912686796875, 32.061899640625],
                            [118.946549101563, 32.1057692695313],
                            [118.974722929688, 32.1099343085938],
                            [118.968795195313, 32.0698073554688],
                            [118.9960559375, 32.1051296210938],
                            [119.007345, 32.1138430000001],
                            [119.047047148438, 32.1073220039063],
                            [119.071832304688, 32.1109841132812],
                            [119.08170046875, 32.09819846875],
                            [119.096392851563, 32.0868581367188],
                            [119.080826445313, 32.0472585273438],
                            [119.09170046875, 32.00819846875],
                            [119.11170046875, 31.9927614570313],
                            [119.102926054688, 31.9680178046875],
                            [119.034459257813, 31.9781374335938],
                            [119.028834257813, 31.9401003242188],
                            [119.042345, 31.9381032539062],
                            [119.06408328125, 31.9413161445312],
                            [119.109556914063, 31.9227053046875],
                            [119.114483671875, 31.8893556953125],
                            [119.10170046875, 31.8794875312501],
                            [119.090806914063, 31.865376203125],
                            [119.062027617188, 31.8696291328126],
                            [119.01298953125, 31.84819846875],
                            [118.963604765625, 31.83444846875],
                            [118.9886340625, 31.8151296210938],
                            [118.997345, 31.783843],
                            [118.977345, 31.783843],
                            [118.977345, 31.763843],
                            [118.971519804688, 31.7680178046876],
                            [118.921793242188, 31.7778444648438],
                            [118.902037382813, 31.7903884101563],
                            [118.888780546875, 31.771889875],
                            [118.895128203125, 31.7397682929688],
                            [118.932432890625, 31.7130300117188],
                            [118.941519804688, 31.6716701484375],
                            [118.912037382813, 31.6903884101563],
                            [118.883092070313, 31.6500075507813],
                            [118.831519804688, 31.6396681953126],
                            [118.827345, 31.633843],
                            [118.7946496875, 31.6209914375001],
                            [118.7795715625, 31.6578420234375],
                            [118.797154570313, 31.6714138007813],
                            [118.746910429688, 31.68819846875],
                            [118.7321496875, 31.6351784492188],
                            [118.697345, 31.6403200507813],
                            [118.682310820313, 31.6380983710938],
                            [118.647345, 31.643843],
                            [118.640704375, 31.657202375],
                            [118.637345, 31.683843],
                            [118.663531523438, 31.6876564765625],
                            [118.685660429688, 31.7031935859375],
                            [118.677750273438, 31.7285939765626],
                            [118.646300078125, 31.73931175],
                            [118.631539335938, 31.7632643867188],
                            [118.612345, 31.7572853828125],
                            [118.601886015625, 31.7605422187501],
                            [118.583531523438, 31.7476564765625],
                            [118.552740507813, 31.7371633125],
                            [118.517891875, 31.7480178046875],
                            [118.536011992188, 31.759184796875],
                            [118.511158476563, 31.7676564765625],
                            [118.492608671875, 31.7806789375],
                            [118.477345, 31.7738430000001],
                            [118.480704375, 31.800483625],
                            [118.493985625, 31.827202375],
                            [118.497345, 31.843843],
                            [118.55888796875, 31.9152761054688],
                            [118.587345, 31.9238430000001],
                            [118.591226835938, 31.886977765625],
                            [118.639928007813, 31.8718093085938],
                            [118.656666289063, 31.8989723945313],
                            [118.677345, 31.903843]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "六合区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.737345, 32.183843],
                            [118.733922148438, 32.1716506171876],
                            [118.725152617188, 32.1804201484375],
                            [118.737345, 32.183843]
                        ]
                    ],
                    [
                        [
                            [118.737345, 32.183843],
                            [118.734801054688, 32.2012990546875],
                            [118.719888945313, 32.2163869453126],
                            [118.714801054688, 32.2512990546876],
                            [118.667345, 32.253843],
                            [118.661783476563, 32.2697072578125],
                            [118.662545195313, 32.288843],
                            [118.6617590625, 32.3086647773438],
                            [118.672535429688, 32.3186525703126],
                            [118.682154570313, 32.3290334296875],
                            [118.702808867188, 32.3387819648438],
                            [118.691373320313, 32.3493752265625],
                            [118.692550078125, 32.3790212226563],
                            [118.681373320313, 32.3893752265625],
                            [118.682545195313, 32.4188430000001],
                            [118.682144804688, 32.4288430000001],
                            [118.683736601563, 32.4689064765625],
                            [118.592154570313, 32.4786525703125],
                            [118.582535429688, 32.490122296875],
                            [118.6029309375, 32.5090212226563],
                            [118.602144804688, 32.528843],
                            [118.602550078125, 32.5390236640625],
                            [118.55283328125, 32.5711305976563],
                            [118.58505984375, 32.6009914375],
                            [118.632408476563, 32.5885866523438],
                            [118.652178984375, 32.5990480781251],
                            [118.691461210938, 32.5974904609376],
                            [118.697345, 32.603843],
                            [118.707345, 32.6163307929688],
                            [118.722799101563, 32.5970339179688],
                            [118.759210234375, 32.6015627265625],
                            [118.787345, 32.585024640625],
                            [118.81267703125, 32.5999172187501],
                            [118.825538359375, 32.5693971992188],
                            [118.862896757813, 32.5782888007813],
                            [118.896920195313, 32.5982888007813],
                            [118.903170195313, 32.5889943671875],
                            [118.890284453125, 32.5554763007813],
                            [118.930045195313, 32.5604225898437],
                            [118.973702421875, 32.505903546875],
                            [119.030079375, 32.512915265625],
                            [119.041793242188, 32.4982888007813],
                            [119.052896757813, 32.4893971992188],
                            [119.057345, 32.4638430000001],
                            [119.01994265625, 32.453149640625],
                            [119.023023710938, 32.4283888984376],
                            [119.00361453125, 32.41284690625],
                            [119.033590117188, 32.3888430000001],
                            [119.021099882813, 32.378843],
                            [119.033023710938, 32.3692971015625],
                            [119.031099882813, 32.353843],
                            [119.032965117188, 32.338843],
                            [119.029859648438, 32.3138430000001],
                            [119.036500273438, 32.2604396796876],
                            [119.077345, 32.243843],
                            [119.035513945313, 32.1916091132813],
                            [118.9233996875, 32.1735353828126],
                            [118.869210234375, 32.189028546875],
                            [118.829761992188, 32.2382888007813],
                            [118.780357695313, 32.2225807929687],
                            [118.757345, 32.1938430000001],
                            [118.737345, 32.183843]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "浦口区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [118.737345, 32.183843],
                            [118.725152617188, 32.1804201484375],
                            [118.733922148438, 32.1716506171876],
                            [118.757345, 32.1938430000001],
                            [118.767345, 32.1938430000001],
                            [118.767345, 32.133843],
                            [118.740704375, 32.120483625],
                            [118.727345, 32.093843],
                            [118.699053984375, 32.0685646796875],
                            [118.647345, 31.973843],
                            [118.591793242188, 31.9293971992188],
                            [118.587345, 31.9238430000001],
                            [118.55888796875, 31.9152761054688],
                            [118.497345, 31.843843],
                            [118.481881132813, 31.8483815742188],
                            [118.460968046875, 31.860356671875],
                            [118.463287382813, 31.8830763984375],
                            [118.381881132813, 31.9183815742188],
                            [118.358956328125, 31.9315114570313],
                            [118.372882109375, 31.9685768867188],
                            [118.371793242188, 31.979233625],
                            [118.382808867188, 31.9883815742188],
                            [118.39474734375, 32.0159157539062],
                            [118.381803007813, 32.038520734375],
                            [118.382896757813, 32.049233625],
                            [118.377345, 32.053843],
                            [118.390704375, 32.080483625],
                            [118.417345, 32.0838430000001],
                            [118.463531523438, 32.1076564765625],
                            [118.471158476563, 32.1200295234375],
                            [118.500382109375, 32.1380373359375],
                            [118.487926054688, 32.1780373359375],
                            [118.503531523438, 32.1876564765625],
                            [118.507345, 32.1938430000001],
                            [118.622896757813, 32.2082888007812],
                            [118.658199492188, 32.2218605781251],
                            [118.667345, 32.253843],
                            [118.714801054688, 32.2512990546876],
                            [118.719888945313, 32.2163869453126],
                            [118.734801054688, 32.2012990546875],
                            [118.737345, 32.183843]
                        ]
                    ]
                ]
            }
        }, {
            "type": "Feature",
            "properties": {
                "name": "栖霞区"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [119.237345, 32.213843],
                            [119.196417265625, 32.1870510078125],
                            [119.177345, 32.1908180976563],
                            [119.157345, 32.1868679023438],
                            [119.132345, 32.1918068671875],
                            [119.07162234375, 32.1798073554688],
                            [119.063170195313, 32.1680178046875],
                            [119.041519804688, 32.1596681953125],
                            [119.014991484375, 32.1428249335938],
                            [119.007345, 32.1138430000001],
                            [118.9960559375, 32.1051296210938],
                            [118.968795195313, 32.0698073554688],
                            [118.974722929688, 32.1099343085938],
                            [118.946549101563, 32.1057692695313],
                            [118.912686796875, 32.061899640625],
                            [118.90162234375, 32.0348635078126],
                            [118.887345, 32.023843],
                            [118.879698515625, 32.0420436835938],
                            [118.883468046875, 32.058843],
                            [118.878980742188, 32.0788430000001],
                            [118.911016875, 32.0908303046875],
                            [118.857867460938, 32.1079274726563],
                            [118.812066679688, 32.0976589179688],
                            [118.797345, 32.103843],
                            [118.793985625, 32.120483625],
                            [118.767345, 32.133843],
                            [118.767345, 32.1938430000001],
                            [118.757345, 32.1938430000001],
                            [118.780357695313, 32.2225807929687],
                            [118.829761992188, 32.2382888007813],
                            [118.869210234375, 32.189028546875],
                            [118.9233996875, 32.1735353828126],
                            [119.035513945313, 32.1916091132813],
                            [119.077345, 32.243843],
                            [119.173531523438, 32.2400295234375],
                            [119.211158476563, 32.2276564765625],
                            [119.237345, 32.223843],
                            [119.237345, 32.213843]
                        ]
                    ]
                ]
            }
        }]
    });
}));
